const Smsfailed = ({ setSms }) => {


 return (
     <div className='sms_failed'>
         <div className='txt' style={{ textAlign: 'center' }}>
             <p style={{ fontSize: 'var(--font-body)', whiteSpace: 'normal' }}>문자를 못 받으셨을 경우</p>
             <p style={{ fontSize: 'var(--font-body)', whiteSpace: 'normal' }}><b style={{ color: 'var(--danger-text)' }}>관리자</b>에게 문의 부탁드립니다.</p>
         </div>
         <div className='btn_box' style={{ paddingTop: '14px', textAlign: 'center' }}>
             <button
                 type='button'
                 onClick={() => {
                     console.log('clicked???')
                     setSms(prev => !prev)
                 }}
                 style={{
                     padding: '0 18px',
                     minHeight: '32px',
                     backgroundColor: 'var(--panel)',
                     border: '1px solid var(--border)',
                     color: 'var(--text)',
                     borderRadius: 'var(--radius)',
                 }}
             >확인</button>
         </div>
     </div>
 )
}

export default Smsfailed